import { RectPos } from "./Dropdown.interface";

export const setPosStyles = (el: HTMLElement, newPos: RectPos): void => {
  /** Attention !!! Direct update of styles property !!! */
  Object.keys(newPos).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    el.style[key] = newPos[key];
  });
};
